import React from 'react';
import DatePicker from 'react-datepicker';
import utils from 'utils/utils';
import Col from 'components/col';

module.exports = React.createClass({

  propTypes: {
    size: React.PropTypes.string,
    label: React.PropTypes.string
  },

  handleChange(date){
    if (typeof this.props.onChange == 'function') {
      this.props.onChange(date);
    } else if (this.props.valueLink && typeof this.props.valueLink.requestChange == 'function') {
      this.props.valueLink.requestChange(date);
    }
  },

  render(){
    var className = ((this.props.className) || 'form-control');
    var value;

    if (this.props.valueLink) {
      value = this.props.valueLink.value || null;
    } else {
      value = this.props.value || null;
    }

    var props = utils.extend({},this.props);

    delete props.valueLink;
    delete props.onChange;
    delete props.value;
    delete props.type;

    return (
      <Col size={this.props.size} className='form-group'>
        <label>{this.props.label}</label>
        <DatePicker selected={value} onChange={this.handleChange} className={className} {...props} />
      </Col>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/components/form-datepicker.js
 **/